import { render, staticRenderFns } from "./AddBeneficiary.vue?vue&type=template&id=261fd62f&"
import script from "./AddBeneficiary.vue?vue&type=script&lang=js&"
export * from "./AddBeneficiary.vue?vue&type=script&lang=js&"
import style0 from "./AddBeneficiary.vue?vue&type=style&index=0&id=261fd62f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports